<div class="container-fluid bg-white layout-wrapper">
  <div class="row">
    <!-- Sidebar -->
    <div class="col-auto p-0">
      <app-side-nav></app-side-nav>
    </div>

    <!-- Main Content -->
    <div class="col px-3 mt-3">
      <!-- Page Heading -->
      <div class="container px-0">
        <div class="row align-items-center mb-4">
          <div class="col-6">
            <h4 class="study-heading">
              <span class="text-muted fw-light">Data Management /</span> Data
              View
            </h4>
          </div>
        </div>
      </div>

      <!-- Study Selection Section -->
      <div class="container px-0 mb-4">
        <div class="row gy-3 align-items-end">
          <!-- Study Selection Dropdown -->
          <div class="col-12 col-md-6 col-lg-4">
            <label class="form-label fw-bold">Select Study Name</label>

            <div
              class="custom-dropdown-container"
              [class.active]="isStudyDropdownOpen"
            >
              <div
                class="custom-dropdown-trigger"
                (click)="toggleStudyDropdown()"
                [class.active]="isStudyDropdownOpen"
              >
                <span *ngIf="!selectedStudyName" class="dropdown-placeholder">
                  Select study name
                </span>
                <span *ngIf="selectedStudyName">{{ selectedStudyName }}</span>
                <i class="bx bx-chevron-down dropdown-arrow"></i>
              </div>

              <div class="custom-dropdown-list" *ngIf="isStudyDropdownOpen">
                <div class="dropdown-header">
                  <input
                    type="text"
                    class="form-control"
                    placeholder="Search studies..."
                    [(ngModel)]="studySearchText"
                    (input)="filterStudies()"
                  />
                </div>

                <div class="dropdown-items">
                  <div
                    class="dropdown-item-custom"
                    *ngFor="let study of filteredStudies"
                    [class.selected]="
                      selectedStudyId === (study.id || study.study_id)
                    "
                    (click)="selectStudy(study)"
                  >
                    <div class="study-item">
                      <div class="study-info">
                        <div class="study-name">
                          {{ study.name || study.study_name }}
                        </div>
                      </div>
                      <i
                        class="bx bx-check"
                        *ngIf="selectedStudyId === (study.id || study.study_id)"
                      ></i>
                    </div>
                  </div>

                  <div
                    class="dropdown-item-custom text-center text-muted"
                    *ngIf="filteredStudies.length === 0"
                  >
                    No studies found
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- Submit Button -->
          <div class="col-12 col-md-3 col-lg-2">
            <button
              class="btn custom-button w-100"
              (click)="submitStudySelection()"
              [disabled]="!selectedStudyId"
            >
              Submit
            </button>
          </div>
        </div>
      </div>

      <div
        class="filter-row d-flex flex-wrap gap-2 mb-3 mt-2 align-items-center"
      >
        <div class="flex-grow-1" style="width: 180px">
          <select
            [(ngModel)]="locationFilter"
            class="form-select cursor-pointer"
          >
            <option value="" disabled selected hidden>
              Filter By Location
            </option>
            <option value="">All Locations</option>
            <option
              *ngFor="let location of availableLocations"
              [value]="location"
            >
              {{ location }}
            </option>
          </select>
        </div>

        <div class="flex-grow-1" style="width: 180px">
          <select
            [(ngModel)]="subjectFilter"
            class="form-select cursor-pointer"
          >
            <option value="" disabled selected hidden>Filter By Participant</option>
            <option value="">All Participants</option>
            <option *ngFor="let subject of availableSubjects" [value]="subject">
              {{ subject }}
            </option>
          </select>
        </div>

        <div class="flex-grow-1" style="width: 230px">
          <div class="custom-dropdown-container">
            <div
              class="custom-dropdown-trigger d-flex justify-content-between align-items-center"
              (click)="toggleFolderDropdown()"
            >
              <span>{{ getFolderFilterLabel() }}</span>
              <i class="bx bx-chevron-down"></i>
            </div>
            <div class="custom-dropdown-list" *ngIf="showFolderDropdown">
              <div
                *ngFor="let folder of folderOptions"
                class="custom-dropdown-item d-flex align-items-center"
                (click)="$event.stopPropagation()"
              >
                <input
                  type="checkbox"
                  class="form-check-input me-2"
                  [checked]="folderCheckboxes[folder.id] || false"
                  (change)="toggleFolderCheckbox(folder.id)"
                />
                <span>{{ folder.name }}</span>
              </div>
              <div
                *ngIf="folderOptions.length === 0"
                class="custom-dropdown-item text-muted"
              >
                No folders available
              </div>
            </div>
          </div>
        </div>

        <div class="flex-grow-1" style="width: 230px">
          <div class="custom-dropdown-container">
            <div
              class="custom-dropdown-trigger d-flex justify-content-between align-items-center"
              (click)="toggleFormDropdown()"
            >
              <span>{{ getFormFilterLabel() }}</span>
              <i class="bx bx-chevron-down"></i>
            </div>
            <div class="custom-dropdown-list" *ngIf="showFormDropdown">
              <div
                *ngFor="let form of getFilteredFormOptions()"
                class="custom-dropdown-item d-flex align-items-center"
                (click)="$event.stopPropagation()"
              >
                <input
                  type="checkbox"
                  class="form-check-input me-2"
                  [checked]="formCheckboxes[form.id] || false"
                  (change)="toggleFormCheckbox(form.id)"
                />
                <span>{{ form.name }}</span>
              </div>
              <div
                *ngIf="getFilteredFormOptions().length === 0"
                class="custom-dropdown-item text-muted"
              >
                No forms available
              </div>
            </div>
          </div>
        </div>

        <div class="flex-grow-1" style="width: 230px">
          <div class="custom-dropdown-container">
            <div
              class="custom-dropdown-trigger d-flex justify-content-between align-items-center"
              (click)="toggleFieldDropdown()"
            >
              <span>{{ getFieldFilterLabel() }}</span>
              <i class="bx bx-chevron-down"></i>
            </div>
            <div class="custom-dropdown-list" *ngIf="showFieldDropdown">
              <div
                *ngFor="let field of availableFields"
                class="custom-dropdown-item d-flex align-items-center"
                (click)="$event.stopPropagation()"
              >
                <input
                  type="checkbox"
                  class="form-check-input me-2"
                  [checked]="fieldCheckboxes[field] || false"
                  (change)="toggleFieldCheckbox(field)"
                />
                <span>{{ field }}</span>
              </div>
              <div
                *ngIf="availableFields.length === 0"
                class="custom-dropdown-item text-muted"
              >
                No fields available
              </div>
            </div>
          </div>
        </div>

        <div class="d-flex gap-2 flex-wrap">
          <button class="btn custom-button" (click)="onSearch()">Search</button>
          <button
            class="btn custom-button"
            (click)="downloadCSV()"
            [disabled]="!selectedStudyId || loading || isGeneratingPDF"
          >
            <i class="bx bx-download me-1" *ngIf="!isGeneratingPDF"></i>
            <span
              class="spinner-border spinner-border-sm me-1"
              *ngIf="isGeneratingPDF"
              role="status"
            ></span>
            {{ isGeneratingPDF ? 'Generating...' : 'Download Excel' }}
          </button>

          <button class="btn custom-button" (click)="clearFilters()">
            Clear
          </button>
        </div>
      </div>

      <!-- Loader -->
      <div
        *ngIf="loading"
        class="d-flex justify-content-center align-items-center"
        style="height: 150px"
      >
        <div class="spinner-border text-purple"></div>
      </div>

      <!-- Table Section -->
      <div class="card" *ngIf="!loading && paginatedData.length > 0">
        <div class="table-responsive rounded">
          <table class="table table-hover">
            <thead>
              <tr>
                <th class="text-nowrap">Study Name</th>
                <th class="text-nowrap">Participant Name</th>
                <th class="text-nowrap">Participant ID</th>
                <th class="text-nowrap">Site Location</th>
                <th class="text-nowrap">Folder Name</th>
                <th class="text-nowrap">Form</th>
                <th class="text-nowrap">Field</th>
                <th class="text-nowrap">Value</th>
                <th class="text-nowrap">Document</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let data of paginatedData">
                <td>{{ getStudyNameForRow(data) }}</td>
                <td [title]="data.subject_name || data.subject_id">{{ data.subject_name || data.subject_id }}</td>
                <td [title]="getParticipantIdForRow(data)">{{ getParticipantIdForRow(data) || '-' }}</td>
                <td>{{ data.site_location }}</td>
                <td>{{ data.folder_name || '-' }}</td>
                <td>{{ data.form_name }}</td>
                <td>{{ data.field_name }}</td>

                <td>
                  <ng-container *ngIf="!isTableData(data.value)">
                    <span [title]="formatValueForDisplay(data)">{{
                      formatValueForDisplay(data)
                    }}</span>
                  </ng-container>

                  <ng-container *ngIf="isTableData(data.value)">
                    <button
                      class="btn btn-sm custom-button"
                      (click)="
                        openTablePopup(
                          data.field_name,
                          data.subject_id,
                          data.site_location
                        )
                      "
                    >
                      <i class="bx bx-table me-1"></i> View Table Data
                    </button>
                  </ng-container>
                </td>

                <td>
                  <ng-container *ngIf="data.document_link; else noDoc">
                    <button
                      class="btn btn-outline-primary btn-sm"
                      (click)="openDocument(data.document_link)"
                    >
                      <i class="bx bx-link-external me-1"></i>
                      {{ data.document_name || 'Open Document' }}
                    </button>
                  </ng-container>

                  <ng-template #noDoc>
                    <span class="text-muted">-</span>
                  </ng-template>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <!-- No Data Message -->
      <div
        class="text-center text-muted py-5"
        *ngIf="!loading && paginatedData.length === 0"
      >
        No data found for the selected filters.
      </div>

      <!-- Pagination -->
      <div
        class="d-flex justify-content-center mt-4 mb-5"
        *ngIf="totalUsers > 0"
      >
        <nav>
          <ul class="pagination cursor-pointer">
            <li class="page-item" [class.disabled]="currentPage === 1">
              <a class="page-link" (click)="prevPage()">Previous</a>
            </li>

            <li
              class="page-item mx-1"
              *ngFor="let page of pageRange"
              [class.active]="page === currentPage"
            >
              <a class="page-link" (click)="goToPage(page)">{{ page }}</a>
            </li>

            <li class="page-item" [class.disabled]="currentPage === pages">
              <a class="page-link" (click)="nextPage()">Next</a>
            </li>
          </ul>
        </nav>
      </div>
    </div>
  </div>
</div>

<!-- Table Modal -->
<div class="modal-overlay" *ngIf="isTableModalOpen" (click)="closeTablePopup()">
  <div class="modal-content table-modal" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <div class="modal-title d-flex justify-content-between w-100">
        <div class="d-flex align-items-center">
          <i class="bx bx-table me-2"></i>
          Table Data - {{ tableFieldName }}
        </div>

        <button
          class="btn btn-sm custom-button"
          (click)="exportTableDataAsCSV()"
          [disabled]="tableModalData.length === 0"
        >
          <i class="bx bx-download me-1"></i> Download CSV
        </button>
      </div>
    </div>

    <div class="modal-body">
      <div *ngIf="tableModalColumns.length === 0" class="text-center py-4">
        <i class="bx bx-table display-4 text-muted"></i>
        <p class="text-muted">No data available</p>
      </div>

      <div *ngIf="tableModalColumns.length > 0" class="table-responsive">
        <table class="table table-bordered">
          <thead class="table-dark">
            <tr>
              <th>Sr. No</th>
              <th *ngFor="let column of tableModalColumns">
                {{ column.title }}
              </th>
            </tr>
          </thead>

          <tbody>
            <tr *ngIf="tableModalData.length === 0">
              <td
                class="text-center text-muted"
                [attr.colspan]="tableModalColumns.length + 1"
              >
                No data available
              </td>
            </tr>

            <tr *ngFor="let row of tableModalData; let i = index">
              <td class="text-center fw-bold">{{ i + 1 }}</td>
              <td *ngFor="let column of tableModalColumns">
                <span *ngIf="!row[column.name]">-</span>
                <span *ngIf="row[column.name]">{{ row[column.name] }}</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>

    <div class="modal-footer">
      <button class="btn custom-button" (click)="closeTablePopup()">
        Close
      </button>
    </div>
  </div>
</div>
